import React from 'react';
import { Box } from '@chakra-ui/react';

/**
 * Consistent section wrapper with max-width, padding, and background.
 */
export function SectionContainer({ children, bg = 'bg.900', id, ...props }) {
  return (
    <Box
      as="section"
      id={id}
      bg={bg}
      w="100%"
      py={{ base: '64px', md: '112px' }}
      {...props}
    >
      <Box
        maxW="1200px"
        mx="auto"
        px={{ base: '24px', md: '48px' }}
      >
        {children}
      </Box>
    </Box>
  );
}